import {Component, ElementRef, inject, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {
  Organisation,
  OrganisationControllerService,
  Project,
  ProjectControllerService,
  User,
  UserSimpleDto
} from "../../../../api";
import {ActivatedRoute} from "@angular/router";
import {COMMA, ENTER, SPACE} from "@angular/cdk/keycodes";
import {StateConfigService} from "../../../../services/state/state-config.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatChipInputEvent} from "@angular/material/chips";
import {MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";
import {faTimes} from "@fortawesome/pro-solid-svg-icons/faTimes";
import {faCircleXmark, faPlus, faUserPlus} from "@fortawesome/pro-solid-svg-icons";
import {ThemePalette} from "@angular/material/core";

import {MatInput} from "@angular/material/input";
import {BicButtonComponent, BicPopupComponent} from "@buildinginformationcloud/bic-ui-components";
import {NotificationsService} from "../../../../services/notifications/notifications.service";


export interface ChipColor {
  name: string;
  color: ThemePalette;
}
@Component({
  selector: 'app-add-user-dialog',
  templateUrl: './add-user-dialog.component.html',
  styleUrls: ['./add-user-dialog.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatInput,
    BicButtonComponent,
    BicPopupComponent
  ]
})
export class AddUserDialogComponent implements OnInit {
  data = inject<{
    isProject?: boolean;
    project: Project;
    organisation: Organisation;
  }>(MAT_DIALOG_DATA);
  organisationControllerService = inject(OrganisationControllerService);
  projectControllerService = inject(ProjectControllerService);
  notificationsService = inject(NotificationsService);
  dialogRef = inject<MatDialogRef<AddUserDialogComponent>>(MatDialogRef);
  route = inject(ActivatedRoute);
  private stateConfigService = inject(StateConfigService);


  organisation!: Organisation;
  project!: Project;

  organisationUsers: User[] = [];
  projectUsers: User[] = [];
  filteredUsers: User[] = [];
  usersToAdd: string[] = [];

  separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];

  emailRegx = /^(([^<>+()\[\]\\.,;:\s@"-#$%&=]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,100}))$/;

  @ViewChild('userMail') userMail!: ElementRef<HTMLInputElement>;

  ngOnInit(): void {
    this.project = this.stateConfigService.getProject()!;
    let organisationId = this.data.organisation?.id;
    if (this.stateConfigService.getOrganisationId() != 0  && organisationId != undefined) {
      this.organisationControllerService.getOrganisation(organisationId!).subscribe(organisation => {
        this.organisation = organisation;
        this.organisationControllerService.getOrganisationUsers(this.organisation.id!).subscribe(users => {
          this.organisationUsers = users;
          if(this.project != undefined) {
            this.projectControllerService.getUsers(this.project.id!).subscribe(users => {
              this.projectUsers = users;
              this.filteredUsers = this.organisationUsers.filter(user => !(this.projectUsers.filter(projectUser => projectUser.id == user.id).length > 0));
            });
          }
        });
      });
    }
  }

  addUserByMails(): void {
    if (this.emailRegx.test(this.userMail.nativeElement.value)) {
      this.usersToAdd.push(this.userMail.nativeElement.value);
      this.userMail.nativeElement.value = "";
    } else {
      if(this.userMail.nativeElement.value != ""){
        this.notificationsService.showErrorMessage('Bitte geben Sie eine gültige Emailadresse an!');
      }
    }

    if (this.data.isProject) {
      var projectUsers: UserSimpleDto[] = [];
      this.projectControllerService.getUsers(this.project.id!).subscribe(users => {
        projectUsers = users;
        this.usersToAdd.forEach(mail => {
          if(projectUsers.filter(user => user.mail == mail).length == 0) {
            this.notificationsService.showSuccessMessage(`${mail} wurde zu Projekt ${this.project.name} eingeladen`);
              if(this.usersToAdd.indexOf(mail) == this.usersToAdd.length - 1) {
                this.projectControllerService.inviteToProject(this.usersToAdd, this.project.id!).subscribe(() => {
                  this.dialogRef.close();
                });
              }
          }else{
            this.notificationsService.showErrorMessage('Der Account mit der Email ' + mail + ' ist bereits Mitglied des Projekts!');
            this.usersToAdd.filter(user => user != mail);
            if(this.usersToAdd.indexOf(mail) == this.usersToAdd.length - 1) {
              this.dialogRef.close();
            }
          }
        })
      });

    } else {
      var organisationUsers: UserSimpleDto[] = [];
      this.organisationControllerService.getOrganisationUsers(this.organisation.id!).subscribe(users => {
        organisationUsers = users;
        this.usersToAdd.forEach(mail => {
          if(organisationUsers.filter(user => user.mail == mail).length == 0) {
            this.notificationsService.showSuccessMessage(`${mail} wurde zu Organisation ${this.organisation.name} eingeladen`);
              if(this.usersToAdd.indexOf(mail) == this.usersToAdd.length - 1) {
                this.organisationControllerService.inviteToOrganisation(this.usersToAdd, this.organisation.id!).subscribe(() => {
                  this.dialogRef.close();
                });
              }
          }else{
            this.notificationsService.showErrorMessage('Der Account mit der Email ' + mail + ' ist bereits Mitglied der Organisation!');
            this.usersToAdd.filter(user => user != mail);
            if(this.usersToAdd.indexOf(mail) == this.usersToAdd.length - 1) {
              this.dialogRef.close();
            }
          }
        })
      });
    }
  }

  removeFromToAdd(mail: string): void {
    const index = this.usersToAdd.indexOf(mail);

    if (index >= 0) {
      this.usersToAdd.splice(index, 1);
    }
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    if (value) {
      if(this.emailRegx.test(value)) {
        this.usersToAdd.push(value);
        // Clear the input value
        event.chipInput!.clear();
      }
    }


  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.usersToAdd.push(event.option.viewValue);
    this.userMail.nativeElement.value = '';
  }
  onCancel(): void {
    this.dialogRef.close();
  }
  protected readonly faTimes = faTimes;
  protected readonly faCircleXmark = faCircleXmark;
  protected readonly faPlus = faPlus;
  protected readonly faUserPlus = faUserPlus;
}
